// @flow
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import MainMobileHeadContainer from 'containers/main/MainMobileHeadContainer';
import MainHeadContainer from 'containers/main/MainHeadContainer';
import MainMobileFooter from 'components/main/MainMobileFooter';
import UserTemplate from 'components/user/UserTemplate';
import PageTemplate from 'components/base/PageTemplate';
import CheckoutSuccessTemplateContainer from 'containers/checkout/CheckoutSuccessTemplateContainer';

type Props = {};

class CheckoutSuccess extends Component<Props> {
  render() {
    return (
      <PageTemplate>
        <header>
          <MainHeadContainer />
          <MainMobileHeadContainer />
        </header>
        <UserTemplate>
          <Helmet>
            <title>구매 완료 | 캐시바이</title>
          </Helmet>
          <CheckoutSuccessTemplateContainer />
        </UserTemplate>
        <MainMobileFooter />
      </PageTemplate>
    );
  }
}

export default CheckoutSuccess;



// WEBPACK FOOTER //
// ./src/pages/CheckoutSuccess.js